import { Component, OnInit, ViewChild, Inject, ElementRef } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { TranslateService } from '@ngx-translate/core';
import { ColumnSelectComponent } from '../column-select/column-select.component';

@Component({
  selector: 'app-ticket-report',
  templateUrl: './ticket-report.component.html',
  styleUrls: ['./ticket-report.component.css']
})
export class TicketReportComponent implements OnInit {

  public menu_item_id = '95';

  private dp = [];
  displayedColumns = ['sr', 'record_locator', 'title', 'customer_name_en', 'customer_last_name', 'full_name', 'member_id',
    'type', 'country_name_en', 'gender', 'date_of_birth', 'document_type', 'passport_no', 'passport_expiry_date', 
    'doc_issue_con_code', 'birth_con_code', 'trip_depart_date', 'trip_arrival_date'];

  // displayedColumns2 = ['sr', 'record_locator', 'title', 'customer_name_en', 'customer_last_name', 'member_id',
  //   'type', 'country_name_en', 'gender', 'date_of_birth', 'document_type', 'passport_no',
  //   'passport_expiry_date', 'doc_issue_con_code', 'birth_con_code'];
  // ['member_id', 'invoice_no', 'customer_last_name', 'customer_name_en', 'mobile',
  //   'trip_depart_date', 'trip_arrival_date', 'date_of_birth', 'age', 'passport_no', 'passport_issue_date',
  //   'passport_expiry_date'];

  model = {
    'trip_name': '', 'trip_number': '', 'trip_status': 'active', 'title': 'تقرير التذاكر',
    'trip_id': '0', 'depart_date': new Date(), 'arrival_date': new Date(), 'type_id': 'all',
    'from_airport': '0', 'to_airport': '0', 'flight_id': '0'
  };

  today = new Date().getFullYear() + "-" + (new Date().getMonth() + 1) + "-" + new Date().getDate();

  search_prog = {
    'placeholder': 'اسم البرنامج/ رقم البرنامج', 'class_name': 'longField',
    'table_list': [{
      'table_name': '`trip`', 'selected_no': 'trip_id',
      'field_list': ['trip_name', 'trip_number'],
      'condition': " AND `trip`.`arrival_date` >= '" + this.today + "'"
    }]
  };

  search_airport = {
    'placeholder': 'اسم المطار', 'class_name': 'tdSearchField',
    'table_list': [{
      'table_name': 'airport', 'selected_no': 'airport_id',
      'field_list': ['airport_name', 'airport_name_en', 'airport_code']
    }]
  };

  search_flight = {
    'placeholder': 'اسم رحلة الطيران/ رقم رحلة الطيران', 'class_name': 'longField',
    'table_list': [{
      'table_name': '`flight`', 'selected_no': 'flight_id',
      'field_list': ['flight_name', 'flight_number', 'flight_date']
    }]
  };

  type_list = [
    { 'type_id': 'all', 'type_name': 'الكل', 'type_name_en': 'All' },
    { 'type_id': 'program', 'type_name': 'عقود البرامج السياحية', 'type_name_en': 'Tourism Programs Contracts' },
    { 'type_id': 'special_prog', 'type_name': 'عقود البرامج الخاصة', 'type_name_en': 'Special Programs Contracts' },
    { 'type_id': 'flight', 'type_name': 'عقود رحلات الطيران', 'type_name_en': 'Flight Contracts' }
  ];

  // airport_list = [];

  dialog_data = [{ 'id': 'sr', 'title_ar': 'Number', 'title_en': 'Number', 'checked': '1' },
    { 'id': 'record_locator', 'title_ar': 'Record Locator', 'title_en': 'Record Locator', 'checked': '1' },
    { 'id': 'title', 'title_ar': 'Title', 'title_en': 'Title', 'checked': '1' },
    { 'id': 'customer_name_en', 'title_ar': 'First Name', 'title_en': 'First Name', 'checked': '1' },
    { 'id': 'customer_last_name', 'title_ar': 'Last Name', 'title_en': 'Last Name', 'checked': '1' },
    { 'id': 'full_name', 'title_ar': 'Full Name', 'title_en': 'Full Name', 'checked': '1' },
    { 'id': 'invoice_no', 'title_ar': 'Contract Number', 'title_en': 'Contract Number', 'checked': '0' },
    { 'id': 'member_id', 'title_ar': 'Passenger Number', 'title_en': 'Passenger Number', 'checked': '1' },
    { 'id': 'type', 'title_ar': 'Passenger Type', 'title_en': 'Passenger Type', 'checked': '1' },
    { 'id': 'country_name_en', 'title_ar': 'Nationality', 'title_en': 'Nationality', 'checked': '1' },
    { 'id': 'gender', 'title_ar': 'Gender', 'title_en': 'Gender', 'checked': '1' },
    { 'id': 'date_of_birth', 'title_ar': 'Date of Birth', 'title_en': 'Date of Birth', 'checked': '1' },
    { 'id': 'document_type', 'title_ar': 'Document Type', 'title_en': 'Document Type', 'checked': '1' },
    { 'id': 'passport_no', 'title_ar': 'Document Number', 'title_en': 'Document Number', 'checked': '1' },
    { 'id': 'passport_expiry_date', 'title_ar': 'Document Expiration', 'title_en': 'Document Expiration', 'checked': '1' },
    { 'id': 'doc_issue_con_code', 'title_ar': 'Country Code', 'title_en': 'Country Code', 'checked': '1' },
    { 'id': 'birth_con_code', 'title_ar': 'Birth Country Code', 'title_en': 'Birth Country Code', 'checked': '1' },
    { 'id': 'trip_depart_date', 'title_ar': 'Departure Date', 'title_en': 'Departure Date', 'checked': '1' },
    { 'id': 'trip_arrival_date', 'title_ar': 'Return Date', 'title_en': 'Return Date', 'checked': '1' }
  ];

  dataSource = new MatTableDataSource(this.dp);
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('TABLE') table: ElementRef;
  colDialogRef: MatDialogRef<ColumnSelectComponent>;

  Ticket_Report; Prog_Name; Prog_No; Program_Placeholder;
  Male; Female; Search_Msg; Airport_Name;
  
  constructor(private utils: Utils, public applicationConstants: ApplicationConstants,
    public dialog: MatDialog, public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('Ticket_Report').subscribe((res: string) => {
      this.Ticket_Report = res;
    });
    this.model['title'] = this.Ticket_Report;

    translate.get('Prog_Name').subscribe((res: string) => {
      this.Prog_Name = res;
    });

    translate.get('Prog_No').subscribe((res: string) => {
      this.Prog_No = res;
    });

    translate.get('Program_Placeholder').subscribe((res: string) => {
      this.Program_Placeholder = res;
    });
    this.search_prog.placeholder = this.Program_Placeholder;

    translate.get('Male').subscribe((res: string) => {
      this.Male = res;
    });

    translate.get('Female').subscribe((res: string) => {
      this.Female = res;
    });

    translate.get('Search_Msg').subscribe((res: string) => {
      this.Search_Msg = res;
    });

    translate.get('Airport_Name').subscribe((res: string) => {
      this.Airport_Name = res;
    });
    this.search_airport['placeholder'] = this.Airport_Name;
  }

  ngOnInit() {
    // let query = "SELECT * FROM `airport` WHERE `status` = '1'";
    // let obj = { cmd: 'getList', query: query };
    // this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
    //   .subscribe(data => {
    //     this.applicationConstants.appComp.hideBusyCursor();
    //     this.airport_list = data.data['list'];
    //   });
  }

  onChangeProg = function (search_result: object) {
    this.model['trip_id'] = (search_result['no'] != '' ? search_result['no'] : '0');
  }

  onChangeFromAirport = function (search_result: object) {
    this.model['from_airport'] = (search_result['no'] != '' ? search_result['no'] : '0');
  }

  onChangeToAirport = function (search_result: object) {
    this.model['to_airport'] = (search_result['no'] != '' ? search_result['no'] : '0');
  }

  onChangeFlight = function (search_result: object) {
    this.model['flight_id'] = (search_result['no'] != '' ? search_result['no'] : '0');
  }

  change_status() {
    if (this.model['trip_status'] == 'active')
      this.search_prog['table_list']['0']['condition'] = " AND `trip`.`arrival_date` >= '" + this.today + "'";

    else
      this.search_prog['table_list']['0']['condition'] = " AND `trip`.`arrival_date` < '" + this.today + "'";
  }

  search() {
    if (this.model['depart_date'] == undefined && this.model['arrival_date'] == undefined && 
      (this.model['type_id'] == 'all' || (this.model['type_id'] == 'program' && this.model['trip_id'] == '0') ||
      (this.model['type_id'] == 'special_prog' && this.model['from_airport'] == '0' && this.model['to_airport'] == '0')) || 
      (this.model['type_id'] == 'flight' && this.model['flight_id'] == '0'))
    {
      alert(this.Search_Msg);
      return;
    }

    let obj = { cmd: 'getTicketRep' };

    obj['type_id'] = this.model['type_id'];
    // obj['today'] = this.today;

    if (this.model['type_id'] == 'flight') {
      if (this.model['flight_id'] != '0')
        obj['flight_id'] = this.model['flight_id'];
    }
    else {
      if (this.model['depart_date'] != undefined)
        obj['depart_date'] = this.model['depart_date'].getFullYear() + "-" + (this.model['depart_date'].getMonth() + 1) + "-" +
          this.model['depart_date'].getDate();

      if (this.model['arrival_date'] != undefined)
        obj['arrival_date'] = this.model['arrival_date'].getFullYear() + "-" + (this.model['arrival_date'].getMonth() + 1) + "-" +
          this.model['arrival_date'].getDate();

      if (this.model['type_id'] == 'program' && this.model['trip_id'] != '0')
        obj['trip_id'] = this.model['trip_id'];

      if (this.model['type_id'] == 'special_prog' && this.model['from_airport'] != '0')
        obj['from_airport'] = this.model['from_airport'];
  
      if (this.model['type_id'] == 'special_prog' && this.model['to_airport'] != '0')
        obj['to_airport'] = this.model['to_airport'];
    }
    
    // if (this.model['type_id'] == 'program' && this.model['trip_status'] != '')
    //   obj['trip_status'] = this.model['trip_status'];

    this.utils.invokeHttp(this.applicationConstants.tourismFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        console.log(data);

        this.dp = data.data['list'];
        this.dataSource = new MatTableDataSource(this.dp);
        this.dataSource.sort = this.sort;
      });


    // let condition = "";

    // if (this.model['trip_id'] != '0')
    //   condition += " AND `trip`.`trip_id` = '" + this.model['trip_id'] + "'";

    // // if (this.model['trip_name'] != '')
    // //   condition += " AND `trip`.`trip_name` LIKE '%" + this.model['trip_name'] + "%'";

    // if (this.model['trip_status'] == 'active') {
    //   condition += " AND `trip`.`arrival_date` >= '" + this.today + "'";
    // }

    // else if (this.model['trip_status'] == 'inactive') {
    //   condition += " AND `trip`.`arrival_date` < '" + this.today + "'";
    // }

    // let query = "SELECT `trip_group`.*, `customer`.`customer_last_name`, `customer`.`customer_name_en`, `customer`.`mobile`," +
    //   " `traveler_info`.* , `country`.`country_name_en` FROM `trip_group`, `invoice`, `customer`, `traveler_info`, `trip`, `country`" +
    //   " WHERE `trip_group`.`status` = '1' AND `trip_group`.`invoice_no` = `invoice`.`invoice_no`" +
    //   " AND `traveler_info`.`acct_number` = `customer`.`acct_number` AND `customer`.`acct_number`" +
    //   " = `trip_group`.`member_id` AND `trip`.`trip_id` = `invoice`.`trip_id` AND `country`.`country_id` = `traveler_info`.`nationality` AND" +
    //   " `trip`.`active` = '1' AND `trip_group`.`ticket_count` != '0'" + condition +
    //   " ORDER BY `trip_group`.`invoice_no`";
    // // console.log(query);
    // let obj = { cmd: 'getList', query: query };

    // this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
    //   .subscribe(data => {
    //     this.applicationConstants.appComp.hideBusyCursor();

    //     data.data['list'].forEach(element => {
    //       let birthdate = new Date(element.date_of_birth);
    //       let timeDiff = Math.abs(Date.now() - birthdate.getTime());
    //       let age = Math.floor((timeDiff / (1000 * 3600 * 24)) / 365.25);
    //       if (age >= 0 && age <= 2)
    //         element.type = 'Infant';
    //       else if (age > 2 && age <= 12)
    //         element.type = 'Child';
    //       else if (age > 12)
    //         element.type = 'Adult';

    //       if (element.gender == 'f') {
    //         element.title = 'Ms';
    //         element.gender = 'Female';
    //       }
    //       else if (element.gender == 'm' && element.type != 'Adult') {
    //         element.title = 'Mstr';
    //         element.gender = 'Male';
    //       }
    //       else if (element.gender == 'm' && element.type == 'Adult') {
    //         element.title = 'Mr';
    //         element.gender = this.Male;
    //       }

    //       element.document_type = 'Passport';
    //       element.birthdate = birthdate.toDateString();

    //     });

    //     this.dp = data.data['list'];
    //     this.dataSource = new MatTableDataSource(this.dp);
    //     this.dataSource.sort = this.sort;
    //   });
  }

  column_select() {
    this.colDialogRef = this.dialog.open(ColumnSelectComponent, {
      hasBackdrop: false,
      data: this.dialog_data
    });
    this.colDialogRef
      .afterClosed()
      .subscribe(result => {
        if (result != undefined) {
          console.log(result);
          this.dialog_data = result;
          this.displayedColumns = [];
          this.dialog_data.forEach(element => {
            if (element.checked == '1')
              this.displayedColumns.push(element.id);
          });
        }
      });
  }

  print() {
    let html_data = '';
    let form = (document.getElementById('form1') as HTMLFormElement);

    html_data = '<table cellpadding="8" cellspacing="0">';
    html_data += '<tr><td width="33%"> ' + this.Ticket_Report + '</td></tr>';
    html_data += '</table>';

    let table = (document.getElementById('prog_table2') as HTMLTableElement);
    html_data += this.utils.printReport(html_data, [{ table: table }], form, 'PDF');
  }

  exportToExcel() {
    this.utils.exportToExcel(this.table.nativeElement, this.model.title);
  }

}
